//
//
//
//
//
//
//
//
//
//
//
//

import QrcodeVue from "qrcode.vue";
export default {
    name: "alliance_shopcode",
    data() {
        return {
            title: "逛云店",
            shopCode:"",
            // codeSize:175,
            mobile:this.$route.query.mobile
        };
    },
    components: { QrcodeVue },
    computed: {},
    created() {
         if(sessionStorage.getItem('token') == null){
            this.get_token(this.url);
         }else{
            this.shop_code();
         }
    },
    methods: {
        //获取token
        get_token(url) {
            this.$EpetJs.Common.approve(url,function(){})  //生成token
        },
        //获取店铺它品小程序码
        shop_code(){
            var self = this;
            this.$EpetJs.Common.get("/v2/public/user/shops/wxacode",{mobile:self.mobile}).then(({ data }) => {
                if (data.status_code == "200") {
                    this.detail = data.data;
                    this.shopCode = this.detail.code_url;
                }
                else{
                    self.$vux.toast.text(data.message);
                }
            });
        },
    }
};
